import type { BuildingInfo } from '@zg-rentals/clickstream';

export function getBuildingInfo(listingAlias?: string): BuildingInfo {
  return {
    building_info: {
      building_id: listingAlias ?? null,
    },
  };
}
